/*import {
  imagesDir
} from './../../../providers/global.config';*/
import {
  NavController,
  NavParams,
  AlertController,
  ModalController,
  LoadingController,
  ViewController,
  MenuController,
  ToastController
} from 'ionic-angular';
import {
  Component,
  OnInit,
  Host,
  AfterViewInit
} from '@angular/core';
import {
  DataManagementService
} from './../../../providers/data-management.service';
import {
  GroupService
} from '../../../providers/group.service';
import {
  Groupe,
  Driver
} from '../../../objects/index';
import {
  DriverService
} from '../../../providers/driver.service';


@Component({
  selector: 'page-chauffeurs',
  templateUrl: 'chauffeurs.html',
})


export class DriverComponent {
  // pag vars
  public maxSize: number = 5;
  public bigTotalItems: number = 175;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  itemsPerPage = 25;
  drivers: Driver[] = [];
  constructor(public menu: MenuController,
    private driverService: DriverService) {
    this.bigCurrentPage = this.driverService.bigCurrentPage;
  }
// Get List chauffeurs
  ngOnInit() {
    this.getListDrivers(this.bigCurrentPage - 1, this.itemsPerPage);
  }
  //
  getListDrivers(page: number, size: number) {
    this.driverService.bigCurrentPage = this.bigCurrentPage;
    this.driverService.getDriversByPageAndSize(this.bigCurrentPage - 1, this.itemsPerPage).subscribe(drivers => {
      this.drivers = drivers.content;
      this.driverService.drivers = this.drivers;
      this.bigTotalItems = drivers.totalElements;

    });
  }
  //open menu
  openmenu() {
    this.menu.open();
  }
  //end
}




// WEBPACK FOOTER //
// ./src/pages/datamana/chauffeurs/chauffeurs.ts